export default __webpack_public_path__ + "static/Wideangle_2.2mm_IRcut-baaa67f9502d7d48b775e09594b87620.webp";